import('./bootstrap').catch((err) => console.error(err));
// eslint-disable-next-line import/no-anonymous-default-export
export default true;
